import { render, staticRenderFns } from "./BillItem.vue?vue&type=template&id=583b3b65&"
import script from "./BillItem.vue?vue&type=script&lang=js&"
export * from "./BillItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports